import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React from "react";
import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { useFormContext } from "react-hook-form";
import PreparationAlfaEvaporation from "./preparation-evaporation";
import { TYPE_ANALYSIS_ALFATOTAL_OPTIONS } from "@app/pages/samples/utils/constants";

const PreparationAlfaTotal = () => {
  const form = useFormContext();
  const { currentPreparation } = useAnalysis();
  const watchTypePreparation = form.watch("typePreparation");

  const configComponent = {
    1: <PreparationAlfaEvaporation type={watchTypePreparation?.name} />, //TODO: Add the rest of the components and create ENUM
    2: <PreparationAlfaEvaporation type={watchTypePreparation?.name} />, //TODO: Add the rest of the components and create ENUM
    3: <PreparationAlfaEvaporation type={watchTypePreparation?.name} />, //TODO: Add the rest of the components and create ENUM
  };

  return (
    <>
      {currentPreparation.index !== undefined && (
        <>
          <ResponsiveFormContainer columns={5} mb={2}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("typePreparation"))}
              name="typePreparation"
              options={TYPE_ANALYSIS_ALFATOTAL_OPTIONS}
              label="Seleccione tipo de preparación"
              getOptionLabel={(option) => option.name || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={
                currentPreparation.id !== undefined ||
                !currentPreparation.canEdit
              }
            />
          </ResponsiveFormContainer>

          {watchTypePreparation && configComponent[watchTypePreparation.id]}
        </>
      )}
    </>
  );
};

export default PreparationAlfaTotal;
